import statusChart from 'Components/UserDashboard/Cards/statusChart.vue'
import mostRatedCategories from 'Components/UserDashboard/Cards/mostRatedCategories.vue'

import globalModals from 'Components/Global/globalModals.vue'
import globalNotifications from 'Components/Global/globalNotifications.vue'
import globalAlerts from 'Components/Global/globalAlerts.vue'
import globalUpgradableSubscription from 'Components/Global/UpgradableSubscription/modalUpgradableSubscription.vue'
import headerContainer from 'Components/Header/headerContainer.vue'
import footerContainer from 'Components/Footer/footerContainer.vue'
import menuAccount from 'Components/Menu/menuAccount.vue'
import menuDashboard from 'Components/Menu/menuDashboard.vue'

import headerPublisher from 'Components/Header/headerPublisher.vue'
const  VueSlider = () => import('vue-slider-component')
import 'vue-slider-component/theme/default.css'

export default {
  install(Vue) {
    Vue.component('headerContainer', headerContainer)
    Vue.component('globalModals', globalModals)
    Vue.component('globalNotifications', globalNotifications)
    Vue.component('menuAccount', menuAccount)
    Vue.component('menuDashboard', menuDashboard)
    Vue.component('statusChart', statusChart)
    Vue.component('mostRatedCategories', mostRatedCategories)

    Vue.component('footerContainer', footerContainer)
    Vue.component('headerPublisher', headerPublisher)
    Vue.component('globalAlerts', globalAlerts)
    Vue.component('VueSlider', VueSlider)
    Vue.component('globalUpgradableSubscription', globalUpgradableSubscription)
  }
}
